const filterNonEmptyValues = (obj) => {
  if (!obj) {
    return
  }
  const result = Array.isArray(obj) ? [] : {} // Initialize the result as an array or object based on the input type
  Object.keys(obj).forEach((key) => {
    // Iterate over each property of the object
    const value = obj[key]
    // Check if the value is non-empty (i.e., not an empty string, array, or false)
    if (value !== '' && value !== false && !(Array.isArray(value) && value.length === 0)) {
      // If the value is an object, apply the function recursively
      if (typeof value === 'object') {
        const nonEmptySubObject = filterNonEmptyValues(value)
        // Add the sub-object to the result if it's not empty
        if (Object.keys(nonEmptySubObject).length > 0) {
          result[key] = nonEmptySubObject
        }
      } else {
        // Directly add the value to the result if it is non-empty
        result[key] = value
      }
    }
  })
  return result // Return the new object containing only non-empty values
}

export default filterNonEmptyValues
